import { TABLE_ITEMS } from "./constants";

interface ProductTableHeadProps {
    visibleColumns?: { label: string; property: any }[];
}

export function ProductTableHead({ visibleColumns = [] }: ProductTableHeadProps) {
    return (
        <thead>
            <tr>
                {visibleColumns.map((item) => (
                    <th
                        key={item.property}
                        className="border-b-2 h-[60px] pl-5 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap"
                    >
                        {item.label}
                    </th>
                ))}
            </tr>
        </thead>
    );
}
